import React from 'react';
import styled from 'styled-components';
import { Button } from '@/components/ui/Button';

const StyledBar = styled.div`
    position: fixed;
    bottom: 24px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1000;
    display: flex;
    align-items: center;
    gap: 16px;
    background: ${({ theme }) => (theme.colors.background.default === '#141414' ? 'rgba(30, 30, 30, 0.92)' : 'rgba(255, 255, 255, 0.92)')};
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border: 1px solid ${({ theme }) => (theme.colors.background.default === '#141414' ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.08)')};
    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.15), 0 8px 10px -6px rgba(0, 0, 0, 0.15);
    padding: 12px 24px;
    border-radius: 9999px;
    animation: floatingBarSlideUp 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards;

    @keyframes floatingBarSlideUp {
        from {
            transform: translate(-50%, 30px);
            opacity: 0;
        }
        to {
            transform: translate(-50%, 0);
            opacity: 1;
        }
    }
`;

const SelectionCountText = styled.span`
    font-size: 14px;
    font-weight: 600;
    color: ${({ theme }) => (theme.colors.background.default === '#141414' ? '#f3f4f6' : '#111827')};
    font-family: var(--font-family-geist);
    margin-right: 8px;
`;

const SubmitAllButton = styled(Button)`
    &&&& {
        background-color: ${({ theme }) => (theme.colors.background.default === '#141414' ? '#1e1e1e' : '#ffffff')} !important;
        color: ${({ theme }) => (theme.colors.background.default === '#141414' ? '#f3f4f6' : '#000000')} !important;
        border: 1px solid ${({ theme }) => (theme.colors.background.default === '#141414' ? '#f3f4f6' : '#000000')} !important;
    }

    &&&&:hover:not(:disabled) {
        background-color: #7543DC !important;
        color: #ffffff !important;
        border-color: #7543DC !important;
    }
`;

const CancelButton = styled(Button)`
    &&&:hover:not(:disabled) {
        background-color: #ff4d4f !important;
        color: #ffffff !important;
        border-color: #ff4d4f !important;
    }
`;

export function FloatingSelectionBar({
    selectedCount,
    onSubmitSelection,
    onSubmitAll,
    onCancel,
    submitSelectionLabel = 'Submit Selection',
    submitAllLabel = 'Submit All',
    cancelLabel = 'Cancel',
    totalCount,
}) {
    const allLabelText = totalCount !== undefined ? `${submitAllLabel} (${totalCount})` : submitAllLabel;

    return (
        <StyledBar>
            <SelectionCountText>
                {selectedCount} {selectedCount === 1 ? 'item' : 'items'} selected
            </SelectionCountText>
            {onSubmitSelection && (
                <Button
                    $primary={true}
                    disabled={selectedCount === 0}
                    onClick={onSubmitSelection}
                    style={{ borderRadius: 9999 }}
                >
                    {submitSelectionLabel}
                </Button>
            )}
            {onSubmitAll && (
                <SubmitAllButton
                    $primary={false}
                    onClick={onSubmitAll}
                    style={{ borderRadius: 9999 }}
                >
                    {allLabelText}
                </SubmitAllButton>
            )}
            {onCancel && (
                <CancelButton
                    $primary={false}
                    type="text"
                    onClick={onCancel}
                    style={{ borderRadius: 9999 }}
                >
                    {cancelLabel}
                </CancelButton>
            )}
        </StyledBar>
    );
}

export default FloatingSelectionBar;
